import {
  CART_KEY,
  CART_PATH
} from 'modules/cart/redux/state'
import getReduxSelector from 'modules/redux/selectors/get'

/**
 * @param state
 * @returns {import('modules/cart/types').CartInfoResp}
 */
const hasShownSpendMoreToUnlockExtraFreeSamplesModalCartSelect = state => {
  const path = CART_PATH[CART_KEY.HAS_SHOWN_SPEND_MORE_TO_UNLOCK_EXTRA_FREE_SAMPLES_MODAL]
  return getReduxSelector(path)(state)
}

export default hasShownSpendMoreToUnlockExtraFreeSamplesModalCartSelect
